<core-navbar></core-navbar>
<core-loader></core-loader>
<router-outlet></router-outlet>
<core-footer></core-footer>
<app-message></app-message>
<ngx-loading-bar></ngx-loading-bar>
